import { Component, Inject, OnInit } from '@angular/core';
import { CapacitacionComponent } from '../../capacitacion.component';

@Component({
  selector: 'app-capacitacion-presencial',
  templateUrl: './capacitacion-presencial.component.html',
  styleUrls: ['./capacitacion-presencial.component.css']
})
export class CapacitacionPresencialComponent implements OnInit {

  constructor(@Inject(CapacitacionComponent) private parent: CapacitacionComponent) { }

  ngOnInit(): void {
  }

  public reporteVisible(item) {

    switch (item) {
      case 'inicio': {
        this.parent.menuMostrar='inicio';
        break;
      }
      case 'presencial': {
        this.parent.menuMostrar='presencial';
        break;
      }
      case 'distancia': {
        this.parent.menuMostrar='distancia';
        break;
      }
     
    }

  }

}
